import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import generateId from "logic/generateId";
import { normalizeFromSearchBarForBackend } from "views/logic/queries/NormalizeTimeRange";
const queryExists = (query) => typeof query === "object" ? !!query.query_string : !!query;
export const validateQuery = ({ queryString, timeRange, streams, streamCategories, filter, ...rest }, userTimezone) => {
  if (!queryExists(queryString) && !queryExists(filter) && !timeRange && !(streams == null ? void 0 : streams.length)) {
    return Promise.resolve({ status: "OK", explanations: [], context: { searched_index_ranges: [] } });
  }
  const payload = {
    query: queryString,
    timerange: timeRange ? normalizeFromSearchBarForBackend(timeRange, userTimezone) : void 0,
    streams,
    stream_categories: streamCategories,
    filter,
    ...rest
  };
  return fetch("POST", qualifyUrl("/search/validate"), payload).then((result) => {
    var _a;
    if (result) {
      const explanations = (_a = result.explanations) == null ? void 0 : _a.map(
        ({
          error_type: errorType,
          error_title: errorTitle,
          error_message: errorMessage,
          begin_line: beginLine,
          end_line: endLine,
          begin_column: beginColumn,
          end_column: endColumn,
          related_property: relatedProperty
        }) => ({
          id: generateId(),
          errorMessage,
          errorType,
          errorTitle,
          beginLine: beginLine ? beginLine - 1 : 0,
          endLine: endLine ? endLine - 1 : 0,
          beginColumn,
          endColumn,
          relatedProperty
        })
      );
      return {
        status: result.status,
        explanations,
        context: result.context
      };
    }
    return void 0;
  }).catch((error) => {
    UserNotification.error(`Validating search query failed with status: ${error}`);
    return {
      status: "OK",
      explanations: [],
      context: { searched_index_ranges: [] }
    };
  });
};
export default validateQuery;
